import { useMutation } from 'react-query';
import { billingEntityService } from 'ogp/services';

export const useArchiveBillingEntity = () => {
  const mutationFn = async (billingEntityId: string) =>
    await billingEntityService.archiveBillingEntity(billingEntityId);

  return useMutation(mutationFn);
};
